import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { BASE_URL, TOP_SALES_PERSON } from "../../../../Constants/Config";
import { useAuthDetails } from "../../../../Common/cookiesHelper";
import { toThunkRejectValue } from "../../../../Common/isRequestCanceled";

const initialState = {
  loading: true,
  topSalesPersonData: [],
  error: "",
};
let controller = null;
export const getTopSalesPerson = createAsyncThunk(
  "topSalesPerson/getTopSalesPerson.",
  async (data, { rejectWithValue }) => {
    const { userTypeData } = useAuthDetails();
    if (controller) {
      controller.abort();
    }

    // Create a new AbortController instance for the current request
    controller = new AbortController();

    try {
      const { token, ...otherUserData } = userTypeData;
      const response = await axios.post(
        BASE_URL + TOP_SALES_PERSON,
        { ...data, ...otherUserData },
        {
          headers: {
            "Content-Type": "multipart/form-data",
            Authorization: `Bearer ${token}`,
          },
          signal: controller.signal,
        }
      );

      //   console.log("top sales person api: ", response);
      if (
        response.data.status &&
        response.data.total_sale_data &&
        response.data.total_sale_data.length > 0
      ) {
        return response.data.total_sale_data;
      } else {
        return [];
      }
    } catch (error) {
      if (axios.isCancel(error) || error.name === "CanceledError") {
        return rejectWithValue({ isCanceled: true }); // Mark as canceled
      }
      const customError = {
        message: toThunkRejectValue(error).message,
        status: toThunkRejectValue(error).status,
        data: error.response ? error.response.data : null,
      };
      return rejectWithValue(customError);
    }
  }
);

const topSalesPersonSlice = createSlice({
  name: "topSalesPerson",
  initialState,
  extraReducers: (builder) => {
    builder.addCase(getTopSalesPerson.pending, (state) => {
      state.loading = true;
      state.isCancel = false;
    });
    builder.addCase(getTopSalesPerson.fulfilled, (state, action) => {
      state.loading = false;
      state.topSalesPersonData = action.payload || [];
      state.error = "";
      state.isCancel = false;
    });
    builder.addCase(getTopSalesPerson.rejected, (state, action) => {
      state.loading = false;
      state.topSalesPersonData = [];
      state.error = action.error.message;
      state.isCancel = action.payload.isCanceled;
    });
  },
});

export default topSalesPersonSlice.reducer;
